import { classNames } from 'primereact/utils'

const checkbox = {
    root: {
        className: classNames(
            'relative',

            // Alignment
            'inline-flex',
            'align-bottom',

            // Size
            'w-6',
            'h-6',

            // Misc

            'select-none'
        ),
    },
    input: ({ props }: { props: any }) => ({
        className: classNames(
            'peer',

            // Size
            'w-full ',
            'h-full',

            // Position
            'absolute',
            'top-0 left-0',
            'z-10',

            // Spacing
            'p-0',
            'm-0',

            // Shape
            'opacity-0',
            'rounded-md',
            'outline-none',
            'border-2 border-surface-200 ',

            // Misc
            'appearance-none',
            { 'cursor-pointer': !props.disabled }
        ),
    }),
    box: ({ props, context }: { props: any; context: any }) => ({
        className: classNames(
            // Alignment
            'flex',
            'items-center',
            'justify-center',

            // Size
            'w-6',
            'h-6',

            // Shape
            'rounded-md',
            'border-2 border-solid',

            // Colors
            {
                'bg-white': !context.checked,
                'bg-grey-dark':
                    !context.checked &&
                    !props.invalid &&
                    (!props.variant || props.variant === 'filled'),
                'bg-allstate-navy border-allstate-navy text-allstate-light-blue':
                    context.checked,
            },

            // Invalid State
            { 'border-red-500': props.invalid },

            // States
            {
                'peer-hover:border-primary-500':
                    !props.disabled && !context.checked && !props.invalid,
                'peer-hover:bg-primary-600 peer-hover:border-primary-700':
                    !props.disabled && context.checked,
                'peer-focus-visible:border-primary-500  peer-focus-visible:ring-2 peer-focus-visible:ring-primary-400/20':
                    !props.disabled,
                'cursor-disabled opacity-60': props.disabled,
                'cursor-pointer': !props.disabled,
            },

            // Transitions
            'transition-colors',
            'duration-200'
        ),
    }),
    icon: ({ context }: { context: any }) => ({
        className: classNames(
            // Font
            'text-base leading-none',

            // Size
            'w-4',
            'h-4',

            // Colors
            'text-allstate-blue',
            { 'text-allstate-light-blue': context.checked },

            // Transitions
            'transition-all',
            'duration-200'
        ),
    }),
}

export default checkbox
